/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import './styles.scss';
const namespace = 'features.iim_review.issue_card.proximity_check';
function formatLabel(label) {
    if (!label)
        return '—';
    const words = label.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1));
    if (label.startsWith('signature_')) {
        return [...words.slice(1), words[0]].join(' ');
    }
    return words.join(' ');
}
function formatDistance(km) {
    if (km < 1) {
        return `${Math.round(km * 1000)} m`;
    }
    return `${km.toFixed(3)} km`;
}
function formatRecordedAt(recordedAt) {
    if (!recordedAt)
        return '—';
    return new Date(recordedAt).toLocaleString();
}
export default function ProximityCheckCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a;
    const status = issue.status || IssueStatusEnum.Detected;
    const { violations, distanceAllowedInKm, totalCoordinatesChecked, violationCount } = issue.issueData;
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    return (React.createElement(IssueLayout, { issueType: "proximity_check", status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement("div", { className: "proximity-check" },
            React.createElement("p", { className: "proximity-check__summary" }, translate('summary', {
                namespace,
                violation_count: violationCount,
                total_coordinates_checked: totalCoordinatesChecked,
                distance_allowed_km: formatDistance(distanceAllowedInKm)
            })),
            React.createElement("div", { className: "qmb-table qmb-table--02 qmb-table--x-full" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, translate('col_coordinate_type', { namespace })),
                            React.createElement("th", null, translate('col_distance', { namespace })),
                            React.createElement("th", null, translate('col_recorded_at', { namespace })))),
                    React.createElement("tbody", null, violations.map((violation, index) => (React.createElement("tr", { key: index },
                        React.createElement("td", null, formatLabel(violation.label)),
                        React.createElement("td", null, formatDistance(violation.distanceKm)),
                        React.createElement("td", null, formatRecordedAt(violation.recordedAt)))))))),
            issue.markedForSuggestion && (!readOnly || ((_a = issue.managerNote) === null || _a === void 0 ? void 0 : _a.trim())) && (React.createElement("div", { className: "proximity-check__manager-note" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
